import { render, staticRenderFns } from "./StaticElement.vue?vue&type=template&id=3af7e452&scoped=true&"
import script from "./StaticElement.vue?vue&type=script&lang=js&"
export * from "./StaticElement.vue?vue&type=script&lang=js&"
import style0 from "./StaticElement.vue?vue&type=style&index=0&id=3af7e452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af7e452",
  null
  
)

export default component.exports